import React from 'react';
import SummaryDetails from '../../ssm-components/summary-details/summary-details';
import FormSelectField from '../../../../components/form/select-field';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import {
  SIP_CONNECT_NO_PABX,
  SIP_CONNECT_PABX_NOT_LISTED,
  SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION,
  SIP_CONNECT_VENDOR,
  SIP_CONNECT_MODEL,
} from '../../../../app-constants';
import FormError from '../../../../components/form/error/error';

const SIPConnectNetworkConnectionDevice = (props) => {
  const {
    summaryTitle,
    summary,
    pabxVendorTooltip,
    formFields: {
      pabxVendor,
      pabxModel,
    },
  } = props.authorableContent;
  const {
    sitesSipConnectPabxVendor,
    handleSipConnectPabxVendorChange,
    sitesSipConnectPabxModel,
    handleSipConnectPabxModelChange,
    siteId,
    formSubmitted,
  } = props;

  const getPabxValueFromKey = key => (pabxVendor.options.filter(option => option.key === key)[0].value);
  const getModelOptions = (vendor) => {
    const modelOptions = pabxModel.options.filter(option => option.key.startsWith(vendor));
    const notListedOption = pabxModel.options.filter(option => option.key === SIP_CONNECT_PABX_NOT_LISTED);
    return [...modelOptions, ...notListedOption];
  };

  const isVendorSelected = vendorKey => (vendorKey !== SIP_CONNECT_NO_PABX &&
    vendorKey !== SIP_CONNECT_PABX_NOT_LISTED && vendorKey !== SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION);

  const showErrorText = (type) => {
    if (type === SIP_CONNECT_VENDOR && (sitesSipConnectPabxVendor[siteId] === undefined ||
      (sitesSipConnectPabxVendor[siteId] !== undefined &&
        sitesSipConnectPabxVendor[siteId] === SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION))) {
      return true;
    } else if (type === SIP_CONNECT_MODEL && (sitesSipConnectPabxModel[siteId] === undefined ||
      sitesSipConnectPabxModel[siteId] === SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)) {
      return true;
    }
    return false;
  };

  return (
    <div className="sip-connect-network-connection-device">
      <SummaryDetails
        summaryTitle={summaryTitle}
        summaryText={summary}
      />
      <div className="row">
        <div className="col-4">
          {pabxVendor.label}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="id-sip-connect-pbax-vendor"
            toolTipText={pabxVendorTooltip}
          />
        </div>
        <div className="col-7">
          <FormSelectField
            id="network-device-pabx-vendor-selection"
            label=""
            options={pabxVendor.options}
            onBlur={handleSipConnectPabxVendorChange}
            placeholder={pabxVendor.placeholder}
            value={sitesSipConnectPabxVendor[siteId] !== undefined ?
              getPabxValueFromKey(sitesSipConnectPabxVendor[siteId]) : getPabxValueFromKey(SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)}
            sendKeyValueOnChange
            initialValuePresent
            showScrollBar
          />
        </div>
      </div>
      {formSubmitted === true && showErrorText(SIP_CONNECT_VENDOR) &&
        <div className="row">
          <div className="col-4" />
          <div className="col-4">
            <FormError errorText={pabxVendor.errorText} />
          </div>
        </div>
      }
      {sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
        <React.Fragment>
          <div className="row">
            <div className="col-4">
              {pabxModel.label}
            </div>
            <div className="col-7">
              <FormSelectField
                id="network-device-pabx-model-selection"
                label=""
                options={sitesSipConnectPabxVendor[siteId] !== undefined ?
                  getModelOptions(sitesSipConnectPabxVendor[siteId]) : []}
                onBlur={handleSipConnectPabxModelChange}
                placeholder={pabxVendor.placeholder}
                value={sitesSipConnectPabxModel[siteId] !== undefined ?
                  sitesSipConnectPabxModel[siteId] : getPabxValueFromKey(SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)}
                initialValuePresent
                showScrollBar
              />
            </div>
          </div>
          {formSubmitted === true && showErrorText(SIP_CONNECT_MODEL) &&
            <div className="row">
              <div className="col-4" />
              <div className="col-4">
                <FormError errorText={pabxModel.errorText} />
              </div>
            </div>
          }
        </React.Fragment>
      }
    </div>
  );
};

export default SIPConnectNetworkConnectionDevice;
